// extracted by mini-css-extract-plugin
export default {"links":"LatestTaxCalculation_links__8eHLz"};